import { render } from "./ModalSolicitarTermino.vue?vue&type=template&id=0809b5a8"
import script from "./ModalSolicitarTermino.vue?vue&type=script&lang=js"
export * from "./ModalSolicitarTermino.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__